import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';

const AdminUsersPanel = ({ onClose }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "signups"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      
      const userData = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        let timestamp = new Date();
        
        // Handle different timestamp formats
        if (data.timestamp) {
          if (data.timestamp.toDate && typeof data.timestamp.toDate === 'function') {
            // Firestore Timestamp
            timestamp = data.timestamp.toDate();
          } else if (data.timestamp instanceof Date) {
            // Already a Date object
            timestamp = data.timestamp;
          } else if (typeof data.timestamp === 'string') {
            // String timestamp
            timestamp = new Date(data.timestamp);
          } else if (data.timestamp.seconds) {
            // Firestore Timestamp object
            timestamp = new Date(data.timestamp.seconds * 1000);
          }
        }
        
        userData.push({
          id: doc.id,
          email: data.email,
          timestamp: timestamp,
          source: data.source || 'Website',
          ...data
        });
      });
      
      setUsers(userData);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
    setLoading(false);
  };

  const filteredUsers = users.filter(user => 
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleExportUsers = () => {
    const csvContent = [
      ['Email', 'Signup Date', 'Source'],
      ...filteredUsers.map(user => [
        user.email,
        user.timestamp.toLocaleDateString(),
        user.source
      ])
    ].map(row => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'users-export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleDeleteUser = (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      alert('User deletion would be implemented here with proper Firebase integration.');
    }
  };

  return (
    <div className="admin-users-panel">
      <div className="admin-panel-header">
        <h3>User Management</h3>
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="users-controls">
        <div className="search-box">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Search users by email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <button className="export-btn" onClick={handleExportUsers}>
          <i className="fas fa-download"></i>
          Export CSV
        </button>
      </div>

      <div className="users-stats">
        <div className="stat-card">
          <div className="stat-number">{users.length}</div>
          <div className="stat-label">Total Users</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{users.filter(u => {
            const today = new Date();
            const userDate = new Date(u.timestamp);
            return userDate.toDateString() === today.toDateString();
          }).length}</div>
          <div className="stat-label">Today</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">{users.filter(u => {
            const weekAgo = new Date();
            weekAgo.setDate(weekAgo.getDate() - 7);
            return new Date(u.timestamp) > weekAgo;
          }).length}</div>
          <div className="stat-label">This Week</div>
        </div>
      </div>

      <div className="users-list">
        {loading ? (
          <div className="loading">Loading users...</div>
        ) : (
          <div className="users-table">
            <div className="table-header">
              <div>Email</div>
              <div>Signup Date</div>
              <div>Source</div>
              <div>Actions</div>
            </div>
            {filteredUsers.map(user => (
              <div key={user.id} className="table-row">
                <div className="user-email">{user.email}</div>
                <div className="user-date">
                  {user.timestamp instanceof Date ? user.timestamp.toLocaleDateString() : 'Invalid Date'}
                </div>
                <div className="user-source">{user.source}</div>
                <div className="user-actions">
                  <button 
                    className="action-btn view"
                    onClick={() => alert(`View details for ${user.email}`)}
                  >
                    <i className="fas fa-eye"></i>
                  </button>
                  <button 
                    className="action-btn delete"
                    onClick={() => handleDeleteUser(user.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminUsersPanel;
